var exports = {
  "k": "x8b4e8595--39ef07--container",
};

module.exports = exports;
